import AbstractDocument from "@/services/firebase/firestore/documents/AbstractDocument";
import { DocumentTypes } from "@/services/firebase/firestore/documents/DocumentTypes";
import { Expose, Type } from "class-transformer";
import ModelWarningBlockNotification from "@models/v2/firebase/warning-blocks/ModelWarningBlockNotification";

export default class DocumentWarningBlocks extends AbstractDocument {
    protected _type: DocumentTypes = DocumentTypes.WARNING_BLOCKS;

    @Expose({name: 'paymentsView'})
    @Type(() => ModelWarningBlockNotification)
    private _paymentsView: ModelWarningBlockNotification[] = [];

    @Expose({name: 'paymentCreateView'})
    @Type(() => ModelWarningBlockNotification)
    private _paymentCreateView: ModelWarningBlockNotification[] = [];

    @Expose({name: 'withdrawalCreatePage'})
    @Type(() => ModelWarningBlockNotification)
    private _withdrawalCreatePage: ModelWarningBlockNotification[] = [];

    constructor() {
        super();
    }

    get paymentsView(): ModelWarningBlockNotification[] {
        return this._paymentsView;
    }

    set paymentsView(value: ModelWarningBlockNotification[]) {
        this._paymentsView = value;
    }

    get paymentCreateView(): ModelWarningBlockNotification[] {
        return this._paymentCreateView;
    }

    set paymentCreateView(value: ModelWarningBlockNotification[]) {
        this._paymentCreateView = value;
    }

    get withdrawalCreatePage(): ModelWarningBlockNotification[] {
        return this._withdrawalCreatePage;
    }

    set withdrawalCreatePage(value: ModelWarningBlockNotification[]) {
        this._withdrawalCreatePage = value;
    }
}
